export default __webpack_public_path__ + "static/media/MaduroTorpedoClosed.4749abab.jpg";